import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import { PersonalNestApi } from "../../../shared/nestjs/gd-only/services/personal.api";
import { GlobalServiceProvider } from "../../../providers/global-service/global-service";
import { NestResponsesProvider } from "../../../shared/nestjs/nest-responses";
import { ServiceagreementSf6Api } from "../../../shared/nestjs/gd-integrated/services/serviceagreement-sf6.api";
import { ResponseAddDto, ResponseSaveDto, ResponseDeleteDto, ResponseListingDto } from "../../../shared/nestjs/gd-integrated/dto/serviceagreement.dto";

@Injectable()
export class ProfileServiceagreementBloc {

  constructor(
    public serviceagreementSf6Api: ServiceagreementSf6Api,
    public personalApi: PersonalNestApi,    
    public globalService: GlobalServiceProvider,
		public nestResponse: NestResponsesProvider,		
  ) {
  }

  add(data): Observable<ResponseAddDto> {
		return this.serviceagreementSf6Api.add(data);
	}

	save(data): Observable<ResponseSaveDto> {
		return this.serviceagreementSf6Api.save(data);
	}

	delete(data): Observable<ResponseDeleteDto> {
		return this.serviceagreementSf6Api.delete(data);
  }

  getPersonal(payload): Promise<any> {
    return new Promise((resolve, reject) => {
      this.personalApi.getPersonal(payload).subscribe(
        async (result) => {
          console.log('BLOC | getPersonal', result)
          let resultData = await this.globalService.convertObjToCamelCase(result.data);
          resolve(resultData);
        }, error => {
          reject(error);
          console.log('getPersonal', error)
        }
      )
    })
  }

  listing(payload): Observable<ResponseListingDto> {
		return this.serviceagreementSf6Api.listing(payload.empId);
	}
}



// WEBPACK FOOTER //
// ./src/bloc/feature/profile/profile-serviceagreement.bloc.ts